export default __webpack_public_path__ + "static/media/folderUp.8f0de2b3.svg";